import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import dharshanDocImage from '../../../../assets/images/Doctorsimages/DHARSHANDR.png'; // Assuming a similar path for dharshan image
import favicon from "../../../../assets/images/favicon.ico";
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const DharshanDoc = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Dr. S. Dharshan | Best Homeopathy Doctor in Chennai | Consultant Homeopathy – H-Cura Clinic";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. S. Dharshan (BHMS), Consultant Homeopathy Doctor in Chennai at H-Cura Clinic. Experienced in holistic homeopathic treatments focusing on natural healing and patient wellness."
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "homeopathy doctor in Chennai, best homeopathy clinic in Chennai, consultant homeopath in Chennai, natural treatment for chronic diseases Chennai, homeopathy for skin and hair problems Chennai, experienced BHMS doctor in Chennai, holistic healing doctor in Chennai, trusted homeopathy specialist near me, Kiruba multispeciality hospital homeopathy doctor, homeopathy treatment for overall wellness Chennai"
      );
    }

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute("href", "https://www.h-cura.com/doctor/dr-s-dharshan-homeopathy-chennai");
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", "https://www.h-cura.com/doctor/dr-s-dharshan-homeopathy-chennai");
      document.head.appendChild(canonicalLink);
    }
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');

    // Add PDF-specific class to container
    container.classList.add('veenadoc-pdf-mode');

    // Store original styles
    const originalStyles = new Map();

    // Temporarily modify styles for PDF capture
    const allElements = container.querySelectorAll('*');
    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });

      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    // Fix hero section height for PDF
    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    // Ensure images are fully loaded and visible
    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
    });

    // Wait a moment for styles to apply
    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        // Remove PDF-specific class
        container.classList.remove('veenadoc-pdf-mode');

        // Restore original styles
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        });

        // Restore hero section
        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        // Define margins for the PDF
        const marginLeft = 10; // 10mm gap on the left
        const marginRight = 10; // 10mm gap on the right to maintain symmetry and prevent cutting
        const availableWidth = pdfWidth - marginLeft - marginRight;

        // Calculate scaling factor to fit the canvas content within the available width
        const scaleFactor = availableWidth / canvasWidth;

        // Apply the scale factor to both width and height to maintain aspect ratio
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;

        // Calculate the number of pages needed for vertical content overflow
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) {
            pdf.addPage();
          }
          // Add image to PDF, using marginLeft for the x coordinate
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save('Dr.Dharshan_S_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        alert('Failed to generate PDF. Please try again.');

        // Remove PDF-specific class
        container.classList.remove('veenadoc-pdf-mode');

        // Restore hero section
        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. S. Dharshan</span>
                  <span className="veenadoc-title-credentials">(BHMS)</span>
                  <span className="veenadoc-title-location">Chennai</span>
                </h1>

               <div className="veenadoc-hero-description">
  <p>
    Dr. S. Dharshan is a trusted homeopathy specialist in Chennai who treats patients, not just symptoms. 
    With a deep understanding of constitutional medicine and individualized care, he helps restore your body's 
    natural healing ability through safe, effective remedies. Whether you're dealing with chronic conditions, 
    skin concerns, allergies, or stress-related issues — Dr. Dharshan's holistic approach at H-Cura Clinic 
    brings lasting relief and true wellness. Experience healthcare that listens, heals, and empowers.
  </p>
</div>


                <div className="veenadoc-hero-actions">
                  <button
                    className="veenadoc-btn-primary-gradient"
                    onClick={() => navigate('/bookconsultation')}
                  >
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={dharshanDocImage} alt="Dr. S. Dharshan – Consultant Homeopathy Doctor in Chennai" className="veenadoc-doctor-image" title='Dr. S. Dharshan | Best Homeopathy Doctor at H-Cura Clinic Chennai' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. S. Dharshan</h2>
                  <p>
                    Dr. S. Dharshan (B.H.M.S.) is a compassionate and dedicated Consultant Homeopathy Doctor in Chennai, known for his patient-centric approach and commitment to long-term holistic healing. With a deep belief in the power of gentle medicine and natural recovery, he helps patients achieve physical, emotional, and mental balance through customized homeopathic treatments. His philosophy — “Well with Pill” — reflects his focus on safe, non-toxic remedies that stimulate the body’s natural healing mechanism rather than merely suppressing symptoms.
                  </p>
                </div>

                {/* Educational Background */}
                <div className="veenadoc-article-block">
                  <h2>Educational Background</h2>
                  <p>
                    Dr. Dharshan completed his Bachelor of Homeopathic Medicine and Surgery (BHMS) from Martin Homeopathy Medical College and Hospital, affiliated with The Tamil Nadu Dr. M. G. R. Medical University, Chennai.
                    This strong academic foundation provided him with in-depth knowledge of anatomy, physiology, pathology, pharmacology, and classical homeopathic principles. His education emphasized both scientific accuracy and individualized healing, equipping him to handle a wide range of acute and chronic conditions effectively.
                  </p>
                  <p>
                    During his studies, he actively participated in clinical postings and patient interactions, where he developed a keen understanding of real-world diagnostic and treatment practices. His passion for homeopathy-based holistic wellness led him to explore the deep connections between physical health, emotional wellbeing, and lifestyle balance — a philosophy he now practices at H-Cura Multispeciality Clinic.
                  </p>
                </div>

                {/* Professional Experience */}
                <div className="veenadoc-article-block">
                  <h2>Professional Experience</h2>
                  <p>
                    Before joining H-Cura Multispeciality Clinic, Dr. Dharshan practiced at Kiruba Multispeciality Hospital, where he provided outpatient consultations and follow-ups for patients of all ages. His experience there gave him valuable exposure to chronic cases such as respiratory allergies, hormonal imbalance, skin disorders, and stress-related issues.
                  </p>
                  <p>
                    At H-Cura, he now continues to offer evidence-based homeopathic care that complements the clinic’s multi-disciplinary approach. He works collaboratively with specialists from other departments, ensuring patients receive well-rounded treatment that addresses both root causes and symptoms.
                  </p>
                  <p>
                    Even within just one year of clinical experience, Dr. Dharshan’s patients consistently appreciate his attentive listening, clear explanations, and result-oriented remedies. Many describe him as a trustworthy and approachable homeopathy doctor in Chennai who brings both comfort and confidence through his consultations.
                  </p>
                </div>

                {/* Treatment Philosophy */}
                <div className="veenadoc-article-block">
                  <h2>Treatment Philosophy – “Well with Pill”</h2>
                  <p>
                    Dr. Dharshan believes that true healing happens from within. Rather than suppressing symptoms, his goal is to restore the body’s natural equilibrium through individualized homeopathic remedies. He views each patient as unique, taking time to understand their medical history, diet, emotional patterns, and lifestyle habits before prescribing any medicine.
                  </p>
                  <p>
                    His guiding principle, “Well with Pill,” is not about quick relief — it is about sustainable wellness. He aims to help patients experience freedom from recurring illnesses, achieve mental peace, and strengthen immunity using gentle, side-effect-free remedies.
                  </p>
                  <p>
                    This integrative philosophy aligns perfectly with H-Cura’s mission to promote holistic wellness through modern diagnostics, compassionate care, and evidence-based natural therapies.
                  </p>
                </div>

                {/* Areas of Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Areas of Expertise at H-Cura</h2>
                  <p>
                    Dr. S. Dharshan’s expertise at H-Cura Multispeciality Clinic, Chennai, spans multiple therapeutic areas, combining traditional homeopathy with lifestyle guidance and preventive care.
                  </p>
                  <h3>1. Homeopathy (Internal &amp; Chronic Care)</h3>
                  <p>He provides individualized treatment for:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Respiratory ailments: asthma, sinusitis, chronic cough, bronchitis.</li>
                    <li>Skin disorders: eczema, psoriasis, urticaria, acne, and pigmentation issues.</li>
                    <li>Hormonal imbalance: thyroid dysfunction, PCOS, irregular menstruation.</li>
                    <li>Digestive problems: gastritis, acidity, IBS, constipation, liver disorders.</li>
                    <li>Allergies and immunity issues: recurrent cold, sneezing, food allergies.</li>
                    <li>Musculoskeletal conditions: joint pain, arthritis, cervical/lumbar spondylosis.</li>
                    <li>Stress and sleep disorders: anxiety, depression, fatigue, and insomnia.</li>
                    <li>Men’s health: hair fall, premature graying, low immunity, and vitality support.</li>
                  </ul>
                  <p>
                    His chronic-care homeopathy programs focus on treating the root cause, preventing recurrence, and improving overall vitality through long-term internal balance.
                  </p>
                  <h3>2. Skin &amp; Homeopathic Dermatology</h3>
                  <p>
                    Homeopathy offers gentle yet effective results for various skin conditions without the side effects of steroids or harsh chemicals. At H-Cura, Dr. Dharshan provides holistic skin treatment for:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Acne and acne scars</li>
                    <li>Eczema and dermatitis</li>
                    <li>Pigmentation and melasma</li>
                    <li>Psoriasis and dry skin</li>
                    <li>Allergic rashes, itching, and urticaria</li>
                  </ul>
                  <p>
                    He combines constitutional homeopathic remedies with nutritional guidance and detox support, ensuring that the skin heals from inside out and regains its natural glow.
                  </p>
                  <h3>3. Hair &amp; Scalp Health</h3>
                  <p>
                    Although not an aesthetic cosmetologist, Dr. Dharshan’s understanding of homeopathic trichology helps in managing scalp and hair-related concerns holistically. His focus remains on internal correction rather than external procedures. He offers:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Homeopathic treatment for hair fall and dandruff</li>
                    <li>Support for androgenetic alopecia (pattern baldness)</li>
                    <li>Nutrition and lifestyle counseling to improve hair strength</li>
                    <li>Stress-management remedies to reduce hair loss triggered by anxiety</li>
                  </ul>
                  <p>
                    These natural approaches at H-Cura promote healthy scalp function and prevent premature hair loss without invasive therapies.
                  </p>
                  <h3>4. Holistic Wellness &amp; Preventive Care</h3>
                  <p>Dr. Dharshan believes that prevention is the cornerstone of health. His programs include:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Lifestyle counseling to improve daily habits</li>
                    <li>Diet and nutrition plans aligned with homeopathic healing</li>
                    <li>Immunity-boosting remedies for seasonal infections</li>
                    <li>Stress-relief therapy using gentle mind-body medicines</li>
                    <li>Sleep improvement programs for better mental clarity</li>
                  </ul>
                  <p>
                    His preventive approach ensures that patients experience sustained energy, emotional balance, and better resistance against chronic diseases.
                  </p>
                </div>

                {/* Patient-Centric Approach */}
                <div className="veenadoc-article-block">
                  <h2>Patient-Centric Approach</h2>
                  <p>
                    Every consultation with Dr. Dharshan begins with a detailed discussion of the patient’s physical, emotional, and mental health. He believes that listening is the first step toward healing. By understanding the underlying cause of the disease — be it stress, heredity, or lifestyle imbalance — he tailors remedies that suit the individual’s constitution.
                  </p>
                  <p>At H-Cura, he follows a 4-Step Healing Process:</p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Root-Cause Identification – in-depth case analysis and clinical observation.</li>
                    <li>Personalized Remedy Selection – precise medicines based on symptoms, temperament, and triggers.</li>
                    <li>Lifestyle &amp; Diet Guidance – practical recommendations for faster recovery.</li>
                    <li>Follow-up and Monitoring – regular feedback sessions to assess progress and adjust dosage if needed.</li>
                  </ul>
                  <p>
                    This method ensures safe, consistent, and long-lasting results that reflect the true essence of homeopathy.
                  </p>
                </div>

                {/* Why Choose Dr. S. Dharshan */}
                <div className="veenadoc-article-block">
                  <h2>Why Choose Dr. S. Dharshan at H-Cura Multispeciality Clinic</h2>
                  <ul className="veenadoc-search-queries-list">
                    <li>✅ Qualified BHMS Doctor from a reputed Tamil Nadu university.</li>
                    <li>✅ Experienced in treating chronic and lifestyle-related disorders.</li>
                    <li>✅ Evidence-based homeopathic practice integrated with modern medical understanding.</li>
                    <li>✅ Personalized and empathetic consultation ensuring comfort and trust.</li>
                    <li>✅ Member of H-Cura’s holistic healthcare team, offering coordinated care with other specialists.</li>
                    <li>✅ Focus on long-term healing rather than temporary symptom suppression.</li>
                  </ul>
                  <p>
                    Patients who visit Dr. Dharshan at H-Cura Clinic, Chennai, often report improved energy levels, emotional stability, and better immunity — a reflection of his gentle yet powerful healing methods.
                  </p>
                </div>

                {/* Patient Feedback & Trust */}
                <div className="veenadoc-article-block">
                  <h2>Patient Feedback &amp; Trust</h2>
                  <p>
                    Dr. Dharshan’s patients describe him as kind, approachable, and deeply committed to their recovery. His calm demeanor and thorough explanations make even first-time homeopathy users feel comfortable. Many testimonials highlight that his remedies not only cured their chronic ailments but also improved sleep, digestion, and mood balance.
                  </p>
                  <p>
                    One recurring sentiment among patients is that Dr. Dharshan’s treatment helped them “feel healthier from inside.” His balanced blend of science, empathy, and homeopathy has earned him growing trust among families in Chennai seeking natural healthcare options.
                  </p>
                </div>

                {/* Integration with H-Cura’s Holistic Ecosystem */}
                <div className="veenadoc-article-block">
                  <h2>Integration with H-Cura’s Holistic Ecosystem</h2>
                  <p>
                    At H-Cura Multispeciality Clinic, Dr. Dharshan works alongside specialists in Dermatology, Aesthetics, Trichology, and Dental Care, ensuring that patients who need combined internal and external management receive coordinated support.
                    For example, those visiting for skin or hair disorders may receive internal homeopathic medicines from Dr. Dharshan along with external dermatological care from H-Cura’s aesthetic doctors — delivering comprehensive, root-to-surface healing.
                  </p>
                  <p>
                    This integrative model positions H-Cura as one of the best holistic health centers in Chennai, where natural medicine complements advanced clinical care.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Conclusion</h2>
                  <p>
                    Dr. S. Dharshan represents the next generation of compassionate Homeopathy Doctors in Chennai — skilled, empathetic, and deeply aligned with holistic wellbeing. His commitment to patient-centered care, continuous learning, and natural healing reflects H-Cura’s philosophy of treating the person, not just the disease.
                  </p>
                  <p>
                    Whether it’s allergies, chronic skin issues, digestive imbalance, hormonal problems, or stress-related fatigue, Dr. Dharshan’s individualized homeopathic care ensures safe, effective, and lasting recovery.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>His mission:</strong> To help every patient live “well with pill” — naturally, gently, and completely.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "Well with Pill"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. S. Dharshan's Philosophy of Care</p>
                  </div>
                  <p>
                    He believes that true healing happens from within, focusing on natural recovery and stimulating the body's healing mechanisms.
                  </p>
                </div>

                {/* Quick Information */}
                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">1+ Year</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Locations:</span>
                      <span className="veenadoc-info-value">Chennai</span>
                    </div>
                  </div>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Locations</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Chennai</h4>
                      <p>Primary practice location</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. S. Dharshan's personalized approach.</p>
                  <button
                    className="veenadoc-sidebar-btn-primary"
                    onClick={() => window.location.href = 'tel:+919964688333'} // Placeholder number
                  >
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                  <button
                    className="veenadoc-sidebar-btn-secondary"
                    onClick={() => window.location.href = 'tel:+919964688333'} // Placeholder number
                  >
                    <span>💬</span>
                    <span>Get Free Assessment</span>
                  </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow />

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  );
};

export default DharshanDoc;
